module.exports = "\n<ngb-tabset class='col p-0 h-100 d-flex flex-column nav-pills-solid' type=\"pills\">\n</ngb-tabset>\t\n"